import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ApiResponse } from '@card-software/nexus-utilities';
import { AssetCategory } from '../models/asset/asset-category';

@Injectable({
  providedIn: 'root',
})
export class CategoryProxyService {
  private readonly httpClient = inject(HttpClient);

  private readonly baseUrl = environment.proxyUrls.assetApi + '/api/v1/category';

  getCategories(): Observable<ApiResponse<AssetCategory[]>> {
    return this.httpClient.get<ApiResponse<AssetCategory[]>>(`${this.baseUrl}/all`);
  }

  upsertCategory(category: AssetCategory): Observable<ApiResponse<AssetCategory>> {
    return this.httpClient.post<ApiResponse<AssetCategory>>(`${this.baseUrl}`, category);
  }
}
